<template>
    <div class="actionLogVue">
        <div v-if="isEmployeeAllowed">
            <div class="o-main-content-area">
                <div class="o-page-top-heading c-responsive-fixwidth">
                    <div class="row c-responsive-fixwidth">
                        <div class="col-md-9">
                            <p class="u-back"><a href="javascript: void(0)" @click="backToSchedule()"><i class="fa fa-chevron-left"></i> Back</a></p>
                        </div>
                        <div class="col-md-3">
                            <div class="input-group stylish-input-group" style="visibility:hidden;">
                                <input type="text" class="form-control" placeholder="Search">
                                <span class="input-group-addon">
                                <button type="submit">
                                    <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                                </button>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row c-responsive-fixwidth">
                        <div class="col-md-12">
                            <h1 class="h1" style="display: inline;">Action Log</h1>
                            <div style="display: inline; float: right;">
                                <a href="javascript: void(0)" @click="csvDownload()" class="c-common-btn c-common-btn--small"><i class="fa fa-download" aria-hidden="true"></i> Download CSV</a>
                            </div>
                            <h3 class="h3" v-if="getActionType != 'clientAction'">{{employeeName}}</h3>
                        </div>
                    </div>
                </div>
            </div>

            <div class="o-ndividualArea c-responsive-fixwidth">
                <div 
                    v-loading="loading" 
                    class="o-ndividualTable" 
                    infinite-scroll-disabled="busy" 
                    infinite-scroll-distance="10" 
                    v-infinite-scroll="{ handler: handleScroll, distance: 10 }"
                    ref="scrollContainer"
                    style="min-height: 1px;"
                >
                    <div v-for="(call, key) in actionLogList" class="o-custom-table-container c-common-box-shadow c-radius3 actionLog-table-align o-overflow-visible" :key="key">
                        <div class="o-calls-table c-common-gradient o-overflow-visible tableList-padding">
                            <div class="calls-table-row phonesheet-table-row">                    
                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="calls-table-cell-inner-table">
                                            <div class="o-accordion-subtext o-rowtable-text">
                                                <span>Job ID:</span>
                                                <div>{{(call.job) ? call.job.job_number :''}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="calls-table-cell-inner-table">
                                            <div class="o-accordion-subtext o-rowtable-text">
                                                <span>Event:</span>
                                                <div>{{(call.job)?call.job.title:''}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="calls-table-cell-inner-table">
                                            <div class="o-accordion-subtext o-rowtable-text">
                                                <span>Timestamp:</span>
                                                <div>{{getGlobalDateTimeFormat(call.updated_at)}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Initiator:</span>
                                            <div>{{call.actionable_type === 'autofill' ? 'Auto-Fill (' + call.user.first_name + ' ' + call.user.last_name + ')' : call.user.first_name + ' ' + call.user.last_name}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Action:</span>
                                            <div>
                                                {{call.actionable_type === 'autofill' ? 'AF ' : ''}}{{call.status.name}}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Affected User:</span>
                                            <div>{{(call.employee && call.employee.employable)?call.employee.employable.first_name+" "+call.employee.employable.last_name:''}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Position:</span>
                                            <div>{{(call.skill)? call.skill.name : ''}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="calls-table-cell">
                                    <div class="table-td-border-right">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Call Start:</span>
                                            <div>{{ getUserDateTimeFormat(call.start) }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="calls-table-cell">
                                    <div class="">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Call End:</span>
                                            <div>{{ getUserDateTimeFormat(call.end) }}</div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>   
                    <div v-if="actionLogList.length==0 && apiData" class="">
                        <div class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                            <div class="col-md-12 no-job-dispaly">
                                <i class="fa fa-frown-o" aria-hidden="true"></i>
                                <br />
                                No Data Stored
                            </div>
                        </div>
                    </div>                                    
                </div>          
            </div>
        </div>
        <div v-else>
            <NotAllowed />
        </div>   
    </div>
</template>

<script>
    import {
        VueEditor
    } from 'vue2-editor';
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';
    import NotAllowed from '@/components/NotAllowed';

    export default {
        components: {
            VueEditor,
            NotAllowed
        },
        data() {
            return {
                isEmployeeAllowed: true,
                loading:false,
                apiData:false,
                actionLogList: [],
                nextPageUrl: '',
                storeMore: [],
                reqHeader: {},
                employeeName:'',
                userDateFormat: null,
                userTimeFormat: null
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                getActionType: 'getActionType',
                employeeId: 'employeeId',
            })
        },
        methods: {
            backToSchedule() {
                this.$router.go(-1);
            },
            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
            },
            getDateForStatus(dateTime) {
                return dateTimeConvert.localDate(dateTime);
            },
            getTimeStamp(dateTime) {
                if (dateTime != 'undefined') {
                    return dateTimeConvert.utcTimeToUserTime(dateTime);
                }
            },
            getGlobalDateTimeFormat(date) {
                return dateTimeConvert.globalDateTime2(date,this.userDateFormat, this.userTimeFormat);
            },

            async handleScroll(position) {               
                if (position !== "bottom") return; 
                await this.loadMore();
            },

            async loadMore() {
                if (this.storeMore.length != 0) {
                    var arr = this.actionLogList;
                    this.storeMore.forEach(function(data) {
                        arr.push(data);
                    });
                    this.storeMore = [];
                    if (this.nextPageUrl != null) {
                        await service.getUrl(this.nextPageUrl, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'employee-id': (this.getActionType == 'employeeAction') ? atob(this.$route.params.empId) : '',
                            'job-id': (this.getActionType == 'employeeAction') ? '' : atob(this.$route.params.empId),
                        }).then((res) => {
                            this.storeMore = res.data.result.data;
                            this.nextPageUrl = res.data.result.next_page_url;
                            this.$Progress.finish();
                        }).catch((err) => {
                            console.log(err);
                            this.$Progress.finish();
                        })
                    } else {
                        this.storeMore = [];
                    }
                }
                this.$nextTick(() => {
                    if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                        this.$refs.scrollContainer._checkScroll();
                    }
                });
            },
            getEmpDetails() {
                this.$Progress.start();
                service.get('employee/' + this.employeeId, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.$Progress.finish();
                    this.employeeName=res.data.result.employable.first_name+" "+res.data.result.employable.last_name;
                    this.userDateFormat = res.data.result.date_format;
                    this.userTimeFormat = res.data.result.time_format;
                }).catch((err) => {
                    console.log(err);
                    if(err.response&&err.response.status&&err.response.status==403) {
                        this.isEmployeeAllowed = false;
                        this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
                    }
                });
            },
            csvDownload(){
                this.$Progress.start();
                service.get('call/actionLogExport',  {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'employee-id': (this.getActionType == 'employeeAction') ? atob(this.$route.params.empId) : '',
                    'job-id': (this.getActionType == 'employeeAction') ? '' : atob(this.$route.params.empId),
                })
                .then((res) => {
                    this.$Progress.finish();
                    this.JSONToCSVConvertor(res.data.result, "Action Log", true);
                }).catch((err) => {
                    console.log(err);
                });
            },
            JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
                var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
                var CSV = '';
                CSV += ReportTitle + '\r\n\n';
                if (ShowLabel) {
                    var row = "";
                    for (var index in arrData[0]) {
                        row += index + ',';
                    }
                    row = row.slice(0, -1);
                    CSV += row + '\r\n';
                }
                for (var i = 0; i < arrData.length; i++) {
                    var row = "";
                    for (var index in arrData[i]) {
                        row += '"' + arrData[i][index] + '",';
                    }
                    row.slice(0, row.length - 1);
                    CSV += row + '\r\n';
                }

                if (CSV == '') {
                    alert("Invalid data");
                    return;
                }
                var fileName = "Job_";
                fileName += ReportTitle.replace(/ /g, "_");
                var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
                var link = document.createElement("a");
                link.href = uri;
                link.style = "visibility:hidden";
                link.download = fileName + ".csv";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },

            getUserDateTimeFormat(date) {
                return dateTimeConvert.getUserDateTime(date,this.userDateFormat,this.userTimeFormat);
            },
        },
        created() {
            this.getEmpDetails();
            this.$Progress.start();
            this.loading=true;
            this.apiData=false;
            service.get('call/actionLog', {
                'Authorization': this.userToken,
                'cs3-context-role': this.userRole,
                'cs3-context-clientId': this.userClientID,
                'employee-id': (this.getActionType == 'employeeAction') ? atob(this.$route.params.empId) : '',
                'job-id': (this.getActionType == 'employeeAction') ? '' : atob(this.$route.params.empId),
            }).then((res) => {
                this.loading=false;
                this.apiData=true;
                this.actionLogList = res.data.result.data;
                this.nextPageUrl = res.data.result.next_page_url;
                if (this.nextPageUrl != null) {
                    this.$Progress.finish();
                    service.getUrl(this.nextPageUrl, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'employee-id': (this.getActionType == 'employeeAction') ? atob(this.$route.params.empId) : '',
                        'job-id': (this.getActionType == 'employeeAction') ? '' : atob(this.$route.params.empId),
                    }).then((res) => {
                        this.storeMore = res.data.result.data;
                        this.nextPageUrl = res.data.result.next_page_url;
                    }).catch((err) => {
                        console.log(err);
                    })
                }
                this.$Progress.finish();
            }).catch((err) => {
                this.loading=false;
                this.apiData=true;
                console.log(err);
                this.$Progress.finish();
                if(err.response&&err.response.status&&err.response.status==403) {
                    this.isEmployeeAllowed = false;
                    this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
                }
            });
        }
    }

</script>
<style scoped>


</style>
